/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint fault entity dictionary.
 * It determines who was responsible for given action - workshop or user
 */
export enum FalconComplaintFaultEntity {
  Workshop = 0,
  User
}
